export const errorTypes = {
  ORDER_FAILURE: 'orderFailure',
  GENERIC: 'generic',
};

export const ERROR_MESSAGE_FALLBACK =
  'Seems like we have run into some trouble and cannot receive your order. Please try again later.';

export const ERROR_TYPE_QUERY_STRING = 'errorType';
